import { render, staticRenderFns } from "./kyc-adv.vue?vue&type=template&id=0babcea7&scoped=true"
import script from "./kyc-adv.vue?vue&type=script&lang=js"
export * from "./kyc-adv.vue?vue&type=script&lang=js"
import style0 from "./kyc-adv.vue?vue&type=style&index=0&id=0babcea7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0babcea7",
  null
  
)

export default component.exports